export default __webpack_public_path__ + "static/media/instagram-icon.f5b87537.png";